<template>
    <Modal>
        <div class="modal-container with-table" slot="modal-container">
            <div class="close" v-on:click="$emit('close')">
                <SvgIcon icon="close"/>
            </div>
            <h2>{{$t('modal.download.headline')}}</h2>
            <p class="text">{{$t('modal.send-email.comment-text')}}</p>
            <div>
                <label class="custom-checkbox">
                    <input type="checkbox" v-model="termsAccepted" v-on:change="downloadContractUrl()">
                    <span class="checkbox">
                                <SvgIcon icon="checkmark-input"/>
                            </span>
                    <div class="text">
                        <p>{{$t('register.accept-terms.text')}} <a target="_blank" href="https://www.rently.dk/terms/">{{$t('register.accept-terms.link')}}</a></p>
                    </div>
                </label>
            </div>
            <div class="button-container w-loader">
                <button class="purple" v-if="!termsAccepted || generatingDownloadPdf" disabled="disabled">
                    {{$t('button.download.label')}}
                </button>
                <a :href="downloadUrlLink" target="_blank" class="button purple" v-on:click="$emit('close')" v-else>{{$t('button.download.label')}}</a>
                <div class="loading-text" v-if="generatingDownloadPdf">
                    <Loader/>
                    <p>{{$t('modal.download.loading')}}</p></div>
            </div>
        </div>
    </Modal>
</template>

<script>
    import PdfViewer from './PdfViewer.vue';
    import SvgIcon from './Svg';
    import Loader from "./Loader";
    import {mapGetters} from "vuex";

    export default {
        name: "DownloadContractModal",
        props: {
            url: {
                type: String,
                required: false
            }
        },
        components: {
            PdfViewer,
            SvgIcon,
            Loader
        },
        computed: {
            ...mapGetters([
                'getToken'
            ]),
        },
        data() {
            return {
                generatingDownloadPdf: false,
                downloadUrlLink: '',
                termsAccepted: false,
            }
        },
        methods: {
            downloadContractUrl: function () {
                this.generatingDownloadPdf = false;
                if(this.url) {
                    this.downloadUrlLink = this.url;
                } else {
                    this.downloadUrlLink = window.config.apiUrl + 'api/contract/' + this.$route.params.id + '?token=' + this.getToken + '&download';
                }

            }
        }
    }
</script>

<style scoped>

</style>
